// Avatar initials (Figma 7725:8944 "JV"). The session only carries the login
// (usually an email), so a full name and an email local part are both
// accepted: "Juan Carlos Vargas" → "JV", "seller_nony@x.pe" → "SN".
export function getInitials(name: string | null | undefined): string {
  const local = (name ?? '').split('@')[0];
  const words = local.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  if (words.length === 0) {
    return '';
  }
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
}
